import type { MarkdownProps } from '../../../components/Markdown/Markdown';

import Markdown from '../../../components/Markdown/Markdown';

import useYjsField from '../../collaboration/useYjsField';
import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const MarkdownField = ({
  onFocus,
  onBlur,
  disabled,
  ...props
}: MarkdownProps) => {
  const field = useFieldContext<string>();
  const errors = useFieldErrors(field.name);
  const yjsField = useYjsField('string');

  const onChange = (value: string) => {
    field.handleChange(value);
    yjsField.update(value);
  };

  /**
   * @todo To investigate - pasting content when other user is changing other fields.
   * When somebody is pasting content to markdown, another user is focused for a moment.
   * This is problematic, bacuse other users lost their focus from other fields.
   *
   */
  const onFieldFocus = (name?: string) => {
    onFocus?.(name);
    yjsField.onFocus();
  };

  const onFieldBlur = (name?: string) => {
    onBlur?.(name);
    field.handleBlur();
    yjsField.onBlur();
  };

  return (
    <Markdown
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={onChange}
      error={errors}
      onFocus={onFieldFocus}
      onBlur={onFieldBlur}
      disabled={disabled || yjsField.isBeingEdited}
      editors={yjsField.fieldEditors}
    />
  );
};

export default MarkdownField;
